// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2umz_","empty":"ModalGraph_empty__Iwqpv"};